<div class="input">
    <mat-select>
        <mat-option *ngIf="!omitirStatus.includes(1)" (click)="OnSelect(1)">Aprobada</mat-option>
        <mat-option *ngIf="!omitirStatus.includes(2)" (click)="OnSelect(2)">Condicionada</mat-option>
        <mat-option *ngIf="!omitirStatus.includes(3)" (click)="OnSelect(3)">Informaciòn Adicional</mat-option>
        <mat-option *ngIf="!omitirStatus.includes(4)" (click)="OnSelect(4)">Rechazada</mat-option>
        <mat-option *ngIf="!omitirStatus.includes(99)" (click)="OnSelect(99)">Cerrada</mat-option>
    </mat-select>
</div>